<script setup lang="ts">
import { mdiCheckBold } from '@mdi/js'

import BaseButton from '@/shared/components/button/BaseButton.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  text: string
  active: boolean
  count: number
}

interface Emits {
  (e: 'click'): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()

const onClick = (): void => {
  if (props.active) return

  emits('click')
}
</script>

<template>
  <BaseButton
    :title="text"
    class="group relative flex items-center justify-between font-medium text-sm px-3 py-2 w-full overflow-hidden"
    :class="
      active
        ? 'text-brand-contrast bg-brand'
        : 'text-gray-700 hover:text-black hover:bg-gray-100 transition-colors'
    "
    @click="onClick"
  >
    <span class="relative z-10">
      {{ text }}
    </span>
    <div class="relative w-10 h-6 grid place-items-center z-10">
      <span
        class="col-start-1 row-start-1 text-xs rounded-2xl px-2 py-0.5 transition-opacity duration-200 ease-in-out"
        :class="
          active
            ? 'bg-surface-inverse text-surface opacity-100'
            : 'bg-gray-500 text-white group-hover:opacity-0'
        "
      >
        {{ count }}
      </span>
      <span
        class="col-start-1 row-start-1 flex items-center justify-center transition-opacity duration-200 ease-in-out"
        :class="active ? 'opacity-0' : 'opacity-0 group-hover:opacity-100'"
      >
        <SvgIcon :path="mdiCheckBold" class="h-5 w-5" />
      </span>
    </div>
  </BaseButton>
</template>
